import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getAllocationDetail = createAsyncThunk(
    "tms/getAllocationDetail",
    async (allocationId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.get(`tms/tenders/${allocationId}/allocations`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const AllocationDetailSlice = createSlice({
    name: "AllocationDetailSlice",
    initialState: {
        loading: false,
        data: null,
        error: null,
    },
    reducers: {
        resetAllocationDetail: (state) => {
            state.loading = false;
            state.data = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAllocationDetail.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getAllocationDetail.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload?.data;
        });
        builder.addCase(getAllocationDetail.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { resetAllocationDetail } = AllocationDetailSlice.actions;
export default AllocationDetailSlice.reducer;
